export function Id(prefix = '', max = 9) {
  return prefix + '_' + Math.random().toString(36).substr(2, max).toUpperCase()
}
